import { isAllowAcceptTypeFile, isFileValid, isRequiredWithObj, strMax, } from '../../utils';
import { makeValidateTitleAndFileForFile } from './common';
export default {
    file: [
        makeValidateTitleAndFileForFile('title', 'uploadFile'),
        isFileValid(),
        isAllowAcceptTypeFile('application/pdf', 'PDFファイルを選択してください'),
    ],
    title: [
        strMax(25, 'タイトルは25文字以内で入力してください'),
        isRequiredWithObj('ファイルを登録する場合、タイトルも入力してください', [
            'uploadFileId',
            'uploadRawFile',
        ]),
    ],
};
